import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonGroup } from '@mui/material';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <ButtonGroup 
      variant="text" 
      size="small"
      sx={{
        '& .MuiButton-root': {
          color: 'white',
          fontFamily: "'Poppins', sans-serif",
          fontSize: '0.9rem',
          backgroundColor: 'transparent',
          padding: '4px 12px',
          border: 'none',
          '&:hover': {
            backgroundColor: 'transparent',
            opacity: 0.8
          }
        },
        '& .MuiButtonGroup-grouped:not(:last-of-type)': {
          borderRight: 'none'
        }
      }}
    >
      <Button
        onClick={() => changeLanguage('en')}
        sx={{
          opacity: i18n.language === 'en' ? 1 : 0.6,
          fontWeight: i18n.language === 'en' ? 600 : 400
        }}
      >
        EN
      </Button>
      <Button
        onClick={() => changeLanguage('pl')}
        sx={{
          opacity: i18n.language === 'pl' ? 1 : 0.6,
          fontWeight: i18n.language === 'pl' ? 600 : 400
        }}
      >
        PL
      </Button>
    </ButtonGroup>
  );
};

export default LanguageSwitcher; 